export default "__VITE_ASSET__79b94aa7__"